import TableBulkImport from '../../table/TableBulkImport'

import { useBulkImportStore } from '@/components/BulkImportModal/hooks/useBulkImportStore'
import { bulkImportStoreActions } from '@/components/BulkImportModal/store/bulk-import.store'

export function ThirdStepBulkImport() {
  const selectedCards = useBulkImportStore(state => state.selectedCards)

  return (
    <TableBulkImport
      handleSelectAllCards={data => {
        bulkImportStoreActions.handleSelectAllCards(data)
      }}
      selectedCards={selectedCards}
      onCellUpdate={data => {
        bulkImportStoreActions.handleUpdateFieldTable(data)
      }}
      onSelectCard={cardId => {
        bulkImportStoreActions.handleSelectCards(cardId)
      }}
      onToggleBulkModals={data => {
        bulkImportStoreActions.updateImportBulkStore({
          openModalBulk: data.open,
          modalBulkType: data.type,
        })
      }}
    />
  )
}
